import { ServiciosAdicionalesGuia, ImportesGuiaDTO, TasasGuia } from "./guia";
import { ImportesServicio } from "./servicio";
/**Modelo de entrada del cotizador */
export interface CotizadorModel {
    Sobres: number;
    Paquetes: CotizadorPaquete[];
    IdColoniaOrigen: number;
    IdColoniaDestino: number;
    ServiciosAdicionales: ServiciosAdicionalesGuiaModel;
}

export interface ServiciosAdicionalesGuiaModel extends ServiciosAdicionalesGuia {
    FXC: boolean;
}

/**Un paquete cotizado */
export interface CotizadorPaquete {
    Cantidad: number;
    Peso: number;
    Largo: number;
    Alto: number;
    Ancho: number;
    ValorDeclarado: number;
    ValorFactura: number;
}

/**Un paquete cotizado con los importes establecidos */
export interface CotizadorPaqueteDTO extends CotizadorPaquete {
    Importes: ImportesServicio;
}


/**Un modelo de salida del cotizador */
export interface CotizadorModelDTO extends CotizadorModel {
    Paquetes: CotizadorPaqueteDTO[];
    ImportesSobre: ImportesServicio;
    ImportesGuia: ImportesGuiaDTO;
    Tasas: TasasGuia;
    DistanciaFlete: number;
}

export const cotizadorInicial: CotizadorModel = {
    IdColoniaDestino: null as any,
    IdColoniaOrigen: null as any,
    Paquetes: [],
    Sobres: 0,
    ServiciosAdicionales: {} as any
};


// WEBPACK FOOTER //
// ./app/models/cotizador.ts